import MainHeaderSearchBar from "../../components/search-bar/search-bar";
import SearchBarResults from "../../components/search-bar-results/search-bar-results";
import { useMainHeader } from "../../main-header.hook";
import { MainHeaderEvents } from "../../main-header.events";
import { useMemo, useState } from "react";
import { CartEmpty } from "../../components/cart-empty";
import styles from "./header-2.module.css";
import { MainHeaderSideMenu } from "../../components/main-header-sidebar-menu";
import { InformationBar } from "../../../../";
import { HEADER_CATEGORIES_EXTEND_ITEMS } from "../../main-header.constants";
import {
  TemplateType,
  AppLink,
  useAppLocation,
  getDomain,
  useCatalogue,
  categoryNormalize,
  makeUrl } from
"@commons-monorepo/index";
import { UiButton } from "@ui-monorepo/index";
import { HeaderVmProps } from "../../types";
import { getRedirectStore } from "../../util/redirect-path";

const Header2 = ({
  overBanner,
  sticky,
  className,
  notFound,
  categories,
  hasServices,
  hasOffers,
  hasWholesale,
  theme,
  data,
  isPortraitInView,
  t,
  goToCheckout,
  partnerWithPrivateDomain
}: HeaderVmProps) => {
  const {
    logEvent,
    themeContext,
    storeMetadata,
    cartProductsQuantity,
    isLoggedIn,
    showSearchBar,
    showCategoriesMenu,
    showCartEmpty,
    showProfileMenu,
    isPopUpDetailOpen,
    creatingShoppingCart,
    setShowCartEmpty,
    handleOnSearch,
    handleShowLogin,
    handleCloseSession,
    handleShowStoreInfo,
    handleCartButton,
    setShowProfileMenu,
    setShowSearchBar,
    handleAboutUs,
    suggestedProducts,
    setSuggestedProducts,
    valueToSearch,
    setValueToSearch,
    partnerProfilePicture,
    informationBar,
    informationBarOffer,
    categoriesChunks,
    categoriesListRef,
    categoryListSelected,
    handleShowCategoriesList,
    handleClickOnCategory,
    handleSelectCategoryList,
    storeUserPathName,
    checkLogo,
    showStoreVerification,
    SHOW_LOGIN_BUTTON
  } = useMainHeader({ data, theme, goToCheckout, isPortraitInView });
  const { isInCategoryView, isInCatalogueRoot } = useCatalogue({
    storeMetadata
  });
  let { pathname } = useAppLocation();
  const { isMobile } = data;
  const [showStoreMenu, setShowStoreMenu] = useState(false);
  const [showHeaderDetail, setShowHeaderDetail] = useState(false);
  const isSticky =
  sticky ||
  !isInCatalogueRoot ||
  themeContext.template.COVER === TemplateType.NONE;
  const isOverBanner =
  overBanner &&
  isPortraitInView &&
  isInCatalogueRoot &&
  themeContext.template.COVER !== TemplateType.NONE;

  const dataAboutUs = storeMetadata.catalogueAboutUs;
  const redirectUrl = useMemo(
    () => getRedirectStore(`/catalogo/${storeMetadata.userNetwork.urlSummer}`, storeMetadata.ownerId),
    []
  );

  const handleMenuButton = () => {
    setShowHeaderDetail(!showHeaderDetail);
    logEvent(MainHeaderEvents.SelectMenu);
  };
  const activeStoreMenu = useMemo((): boolean => {
    return (
      pathname.indexOf("/ofertas") >= 0 ||
      pathname.indexOf("/ventas-mayoreo") >= 0 ||
      pathname.indexOf("/servicios") >= 0);

  }, [pathname]);

  return (
    <div
      className={`${styles.headerComponent} ${
      isSticky ? styles.header2Sticky : ""
      } header2`}>

      {informationBar && !informationBar.hidden &&
      <div className={styles.headerInformationBar}>
          <InformationBar
          information={informationBar}
          offer={informationBarOffer}
          storeMetadata={data?.storeMetadata} />

        </div>}

      <header
        className={`${styles.header2Styled} ${
        isOverBanner ? styles.header2OverBanner : ""
        } ${className || ""}`}>

        <div className={styles.headerContainer}>
          <div className={styles.header2Left}>
            <AppLink
              to={`${redirectUrl}`}
              className={styles.header2LinkHome}
              externalLink={redirectUrl.includes("https")}>

              <img
                src={partnerProfilePicture}
                alt={storeMetadata?.enterpriseName}
                className={`${styles.header2Logo} ${
                storeMetadata?.profilePicConfiguration?.enableRectangle &&
                styles.rectangle
                }`}
                loading='lazy' />

              {!!showStoreVerification &&
              <img src={checkLogo} alt='Check' className={styles.check} />}

            </AppLink>
            {!notFound &&
            <nav className={styles.header2Menu}>
                <ul className={styles.header2Items}>
                  {categories && !!categories.length &&
                <li
                  className={`${styles.header2Item} ${
                  showCategoriesMenu ? styles.active : ""
                  }`}>

                      <span
                    className={`${styles.header2MenuLink} simple ${
                    isInCategoryView ? styles.active : ""
                    }`}
                    onClick={handleShowCategoriesList}>

                        {t("main_header.categories")}
                        <span className={`${styles.arrowDown} icon-arrow-2`} />
                      </span>
                      <div
                    ref={categoriesListRef}
                    className={`${styles.header2SubItems} ${
                    styles.header2SubMenuContainer
                    } ${
                    categories.length > HEADER_CATEGORIES_EXTEND_ITEMS ?
                    styles.header2CategoriesExtend :
                    ""
                    }`}>

                        <h4 className={styles.header2SubItemsTitle}>
                          {t("main_header.categories")}
                        </h4>
                        <nav className={styles.header2CategoriesChunks}>
                          {categoriesChunks.map(
                        (categoriesChunk, indexChunk) =>
                        <ul
                          className={styles.header2Categories}
                          key={`header-category-chunk-${indexChunk}`}>

                                {categoriesChunk.map((item, index) =>
                          <li
                            className={styles.header2SubItem}
                            key={`header-category-${index}`}>

                                    <span className={styles.header2SubMenuLink}>
                                      <AppLink
                                to={`${pathname}/${makeUrl(
                                  pathname,
                                  `categoria/${categoryNormalize(
                                    item.category.id
                                  )}`
                                )}`}
                                className={`${styles.header2CategoryLink}`}
                                onClick={() =>
                                handleClickOnCategory(item.category)}>


                                        {item.category.name}
                                      </AppLink>
                                      {item.subCategories &&
                              <button
                                className={`${
                                styles.header2CategoryButton
                                } ${
                                categoryListSelected === item &&
                                styles.active
                                }`}
                                onClickCapture={() => {
                                  handleSelectCategoryList(item);
                                }}>

                                          <span className='icon-arrow-2' />
                                        </button>}

                                    </span>
                                    {item.subCategories &&
                            categoryListSelected === item &&
                            <ul
                              className={
                              styles.header2SubCategories}>


                                          {item.subCategories.map(
                                (subItem, subIndex) =>
                                <li
                                  className={
                                  styles.header2SubItem}

                                  key={`header-subcategory-${index}-${subIndex}`}>

                                                <AppLink
                                    to={`${pathname}/${makeUrl(
                                      pathname,
                                      `categoria/${categoryNormalize(
                                        item.category.id
                                      )}/${categoryNormalize(
                                        subItem.id
                                      )}`
                                    )}`}
                                    className={`${styles.header2CategoryLink}`}>

                                                  {subItem.name}
                                                </AppLink>
                                              </li>

                              )}
                                        </ul>}

                                  </li>
                          )}
                              </ul>

                      )}
                        </nav>
                      </div>
                    </li>}

                  <li
                  className={`${styles.header2Item} ${styles.header2ItemOptional}`}>

                    <AppLink
                    to={`${pathname}/${makeUrl(
                      pathname,
                      `todos-los-productos`
                    )}`}>

                      <span
                      className={`${styles.header2MenuLink} ${
                      pathname.indexOf("/todos-los-productos") >= 0 ?
                      styles.active :
                      ""
                      }`}>

                        {t("main_header.all_products")}
                      </span>
                    </AppLink>
                  </li>
                  {(hasOffers || hasWholesale || hasServices) &&
                <li
                  className={`${styles.header2Item} ${
                  showStoreMenu ? styles.active : ""
                  }`}>

                      <label
                    className={`${styles.header2MenuLink} simple ${
                    activeStoreMenu ? styles.active : ""
                    }`}
                    htmlFor='headerStoreItem'>

                        {t("main_header.store")}
                        <span className={`${styles.arrowDown} icon-arrow-2`} />
                      </label>
                      <input
                    type='text'
                    id='headerStoreItem'
                    onFocus={() => {
                      setShowStoreMenu(true);
                      logEvent(MainHeaderEvents.SelectHeaderStore, {
                        Template_id: themeContext.templateId
                      });
                    }}
                    onBlur={() => {
                      setTimeout(() => setShowStoreMenu(false), 200);
                    }} />

                      <ul
                    className={`${styles.header2SubItems} ${styles.header2SubMenuContainer}`}>

                        <li
                      className={`${styles.header2SubItem} ${styles.header2SubItemOptional}`}>

                          <AppLink
                        to={`${pathname}/${makeUrl(
                          pathname,
                          `todos-los-productos`
                        )}`}
                        className={styles.header2SubMenuLink}
                        onClick={() =>
                        logEvent(MainHeaderEvents.SelectHeaderOffers, {
                          Template_id: themeContext.templateId
                        })}>


                            {t("main_header.all_products")}
                          </AppLink>
                        </li>
                        {hasOffers &&
                    <li className={styles.header2SubItem}>
                            <AppLink
                        to={`${pathname}/${makeUrl(pathname, `ofertas`)}`}
                        className={styles.header2SubMenuLink}
                        onClick={() =>
                        logEvent(MainHeaderEvents.SelectHeaderOffers, {
                          Template_id: themeContext.templateId
                        })}>


                              {t("main_header.seller")}
                            </AppLink>
                          </li>}

                        {hasWholesale &&
                    <li className={styles.header2SubItem}>
                            <AppLink
                        to={`${pathname}/${makeUrl(
                          pathname,
                          `ventas-mayoreo`
                        )}`}
                        className={styles.header2SubMenuLink}
                        onClick={() =>
                        logEvent(
                          MainHeaderEvents.SelectHeaderWholesale,
                          {
                            Template_id: themeContext.templateId
                          }
                        )}>


                              {t("main_header.wholesale")}
                            </AppLink>
                          </li>}

                        {hasServices &&
                    <li className={styles.header2SubItem}>
                            <AppLink
                        to={`${pathname}/${makeUrl(
                          pathname,
                          `servicios`
                        )}`}
                        className={styles.header2SubMenuLink}
                        onClick={() =>
                        logEvent(
                          MainHeaderEvents.SelectHeaderServices,
                          {
                            Template_id: themeContext.templateId
                          }
                        )}>


                              {t("main_header.services")}
                            </AppLink>
                          </li>}

                        <li
                      className={`${styles.header2SubItem} ${styles.header2SubItemOptional}`}>

                          <AppLink
                        to={`${pathname}/${makeUrl(
                          pathname,
                          `todos-los-productos`
                        )}`}
                        className={styles.header2SubMenuLink}
                        onClick={() =>
                        logEvent(MainHeaderEvents.SelectHeaderOffers, {
                          Template_id: themeContext.templateId
                        })}>


                            {t("main_header.about")}
                          </AppLink>
                        </li>
                        <li
                      className={`${styles.header2SubItem} ${styles.header2SubItemOptional}`}>

                          <AppLink
                        to={`${pathname}/${makeUrl(
                          pathname,
                          `todos-los-productos`
                        )}`}
                        className={styles.header2SubMenuLink}
                        onClick={() =>
                        logEvent(MainHeaderEvents.SelectHeaderOffers, {
                          Template_id: themeContext.templateId
                        })}>


                            {t("main_header.contact")}
                          </AppLink>
                        </li>
                      </ul>
                    </li>}

                  {dataAboutUs &&
                <li
                  className={`${styles.header2Item} ${styles.header2ItemOptional}`}>

                      <span
                    className={`${styles.header2MenuLink} ${
                    pathname.indexOf("/sobre-nosotros") >= 0 ?
                    styles.active :
                    ""
                    }`}
                    onClick={() => {
                      handleAboutUs();
                      logEvent(MainHeaderEvents.SelectWebAboutUsDesktop, {
                        Template_id: themeContext.templateId
                      });
                    }}>

                        {t("main_header.about")}
                      </span>
                    </li>}

                  <li
                  className={`${styles.header2Item} ${styles.header2ItemOptional}`}>

                    <span
                    className={`${styles.header2MenuLink} ${
                    isPopUpDetailOpen ? styles.active : ""
                    }`}
                    onClick={() => {
                      handleShowStoreInfo();
                      logEvent(MainHeaderEvents.SelectHeaderContactUs, {
                        Template_id: themeContext.templateId
                      });
                    }}>

                      {t("main_header.contact")}
                    </span>
                  </li>
                </ul>
              </nav>}

          </div>
          {!notFound &&
          <div className={styles.header2ButtonsGroup}>
              <div
              className={`${styles.header2SearchContainer} ${
              showSearchBar ? styles.show : ""
              }`}>

                <MainHeaderSearchBar
                valueToSearch={valueToSearch}
                setValueToSearch={setValueToSearch}
                setProducts={setSuggestedProducts}
                setShowSearchBar={setShowSearchBar}
                className={styles.desktopSearchBar}
                onSearch={handleOnSearch}
                storeMetadata={storeMetadata}
                isMobile={isMobile} />

                <SearchBarResults
                locale={storeMetadata?.locale}
                currency={storeMetadata?.currency}
                valueToSearch={valueToSearch}
                className={styles.searchBarResults}
                products={suggestedProducts}
                onSearch={handleOnSearch}
                storeMetadata={data?.storeMetadata} />

                <ul
                className={`${styles.header2SubItems} ${styles.header2SubMenuContainer}`}>

                  <li className={styles.header2SubItem}>
                    <a
                    href={`/features/dashboard/perfil?partnerId=${storeUserPathName}`}
                    className={styles.header2SubMenuLink}
                    onClick={() =>
                    logEvent(MainHeaderEvents.SelectViewProfile, {
                      source: "header"
                    })}>


                      <span className='icon-account-circle-outline' />
                      {t("profile.profile_text")}
                    </a>
                  </li>
                  <li className={styles.header2SubItem}>
                    <a
                    href={`/features/dashboard/historial`}
                    className={styles.header2SubMenuLink}
                    onClick={() =>
                    logEvent(MainHeaderEvents.SelectPurchase, {
                      source: "header"
                    })}>


                      <span className='icon-shopping-outline' />
                      {t("profile.my_shopping")}
                    </a>
                  </li>
                  <li className={styles.header2SubItem}>
                    <UiButton
                    theme={theme}
                    className={`${styles.header2SubMenuLink} ${styles.danger}`}
                    onClick={handleCloseSession}>

                      <span className='icon-logout-outline' />
                      {t("profile.logout")}
                    </UiButton>
                  </li>
                </ul>
              </div>
              <button
              role={"button"}
              aria-label='Botón buscar principal'
              className={`${styles.header2Button} ${styles.header2ButtonSearch}`}
              onClick={() => {
                setShowSearchBar(true);
              }}>

                <span className={`${styles.header2ButtonIcon} icon-search`} />
              </button>
              {SHOW_LOGIN_BUTTON && !isLoggedIn && !isMobile &&
            <UiButton
              className={styles.header2ButtonSignin}
              isBlack={!isPortraitInView}
              size='short'
              theme={theme}
              isWhite={overBanner && isInCatalogueRoot}
              onClick={handleShowLogin}>

                  {t("main_header.sign_in")}
                </UiButton>}

              {SHOW_LOGIN_BUTTON && isLoggedIn &&
            <div
              className={`${styles.header2ProfileButton} ${
              showProfileMenu ? styles.active : ""
              }`}>

                  <label
                className={`${styles.header2Button} ${styles.header2ButtonProfile}`}
                htmlFor='headerProfileItem'>

                    <span className={`${styles.header2ButtonIcon} icon-user`} />
                  </label>
                  <input
                type='text'
                id='headerProfileItem'
                onFocus={() => setShowProfileMenu(true)}
                onBlur={() =>
                setTimeout(() => setShowProfileMenu(false), 200)} />


                  <ul
                className={`${styles.header2SubItems} ${styles.header2SubMenuContainer}`}>

                    <li className={styles.header2SubItem}>
                      <a
                    href={`${getDomain()}/features/dashboard/perfil?partnerId=${storeUserPathName}`}
                    className={styles.header2SubMenuLink}
                    onClick={() =>
                    logEvent(MainHeaderEvents.SelectViewProfile, {
                      source: "header"
                    })}>


                        <span className='icon-account-circle-outline' />
                        {t("profile.profile_text")}
                      </a>
                    </li>
                    <li className={styles.header2SubItem}>
                      <a
                    href={`${getDomain()}/features/dashboard/historial`}
                    className={styles.header2SubMenuLink}
                    onClick={() =>
                    logEvent(MainHeaderEvents.SelectPurchase, {
                      source: "header"
                    })}>


                        <span className='icon-shopping-outline' />
                        {t("profile.my_shopping")}
                      </a>
                    </li>
                    <li className={styles.header2SubItem}>
                      <UiButton
                    className={`${styles.header2SubMenuLink} ${styles.danger}`}
                    onClick={handleCloseSession}>

                        <span className='icon-logout-outline' />
                        {t("profile.logout")}
                      </UiButton>
                    </li>
                  </ul>
                </div>}

              <button
              role={"button"}
              aria-label='Botón principal de carrito'
              className={`${styles.header2Button} ${
              !!cartProductsQuantity && styles.active
              }`}
              disabled={creatingShoppingCart}
              onClick={handleCartButton}>

                <span
                className={`${styles.header2ButtonIcon} icon-cart-outline`} />

                {!!cartProductsQuantity &&
              <span
                className={styles.header2ButtonBadge}
                data-testid='main-header-cart-items-number'>

                    {cartProductsQuantity}
                  </span>}

              </button>
              <button
              role={"button"}
              className={`${styles.header2Button} ${styles.header2ButtonMenu}`}
              onClick={handleMenuButton}>

                <span
                className={`${styles.header2ButtonIcon} icon-burger-menu`} />

              </button>
            </div>}

        </div>
        {showHeaderDetail &&
        <MainHeaderSideMenu
          categories={categories}
          hasOffers={hasOffers}
          hasServices={hasServices}
          hasWholesale={hasWholesale}
          theme={theme}
          storeMetadata={storeMetadata}
          onClose={() => setShowHeaderDetail(false)}
          data={data} />}


        {showCartEmpty &&
        <CartEmpty
          className={styles.header2CartEmpty}
          onClose={() => setShowCartEmpty(false)} />}


      </header>
    </div>);

};

export default Header2;